import { useLocation } from "react-router-dom";
import NavigationCards2 from "components/navigation/navigation-cards/navigation-cards2";

export default function UsageReportsIndex() {
    const location = useLocation();
    return (
        <NavigationCards2 route={location.pathname} />
    );
}
